var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.description !== '')?_c('div',[_c('div',{staticClass:"product-description",domProps:{"innerHTML":_vm._s(_vm.description)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }